/**
 * @ngdoc directive
 * @name lspPasswordValidator.directive:lspPasswordValidator
 * @description
 * # lspPassword
 */

function lspPassword(appFactory) {
  const PASSWORD_REGEXP = new RegExp(appFactory.deps.config.passwordRequirementPattern);

  return {
    require: ['ngModel'],
    restrict: 'A',
    link: (scope, elm, attrs, ctrl) => {
      // only apply the validator if ngModel is present and Angular has added the pattern validator
      if (ctrl[0]) {
        // this will overwrite the default Angular pattern validator
        ctrl[0].$validators.pattern = (modelValue) => ctrl[0].$isEmpty(modelValue) || PASSWORD_REGEXP.test(modelValue);
      }
    },
  };
}

lspPassword.$inject = ['appFactory'];

export default lspPassword;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-password-validator/lsp-password-directive.js